import { FC } from "react";
import { useTranslation } from "react-i18next";
import { IInternetOrderGetInfoEditModalProps } from "./interfaces"
import { IOption } from "../../../../../../components/selects/select";
import { SelectControl } from "../../../../../../components/controls/SelectControl";
import { InternetOrderGetInfoOptions } from "./InternetOrderGetInfoOptions";
import { DecimalInputWithMinMax } from "../../../../../../components/controls/inputs";

export const InternetOrderGetInfoEditModal: FC<IInternetOrderGetInfoEditModalProps> = (props) => {
    const { t } = useTranslation();
    const baseT = (value: string) => t("sysOptions.InternetOrderGetInfo." + value);

    const obj = JSON.parse(props.data?.jsonData);
    const value = obj.Value.Value === baseT("Yes") ? baseT("Yes") : baseT("No");
    const days = (obj.Value.Days !== null && Number(obj.Value.Days) > 0) ? Math.floor(Number(obj.Value.Days)) : 0;

    return <>
        <h3>{baseT("Title")}</h3>
        <p>{baseT("Description")}</p>
        <SelectControl
            value = {
                {
                    displayName: value,
                    value: value
                } as IOption
            }
            options = {InternetOrderGetInfoOptions(t)}
            onSelect = {(option) =>{
                obj.Value.Value = option.value;
                props.setData({
                    ...props.data,
                    jsonData: JSON.stringify(obj)
            })
            }
        }
        />
        <DecimalInputWithMinMax
            min = {0}
            value = {days}
            onChange = {(newValue) => {
                obj.Value.Days = newValue;
                props.setData({
                    ...props.data,
                    jsonData: JSON.stringify(obj)
                })
            }}
        />
    </>;
}